import React, { Component } from 'react'
import { connect } from 'react-redux'
import CloudStorage from './cloudStorage/index.jsx'
import PersonalInfo from './personalInfo/index.jsx'

import { clientSide } from '../config_react.js'
const { redirectToStorage } = clientSide[0]

export default class ePassport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            cloudStorageConnected: null,
            translateData: null,
        }
    }

    componentDidMount() {
        this.getUserAuth()
        this.getTranslate()
    }

    getUserAuth = () => {
        fetch(`${redirectToStorage}/pauserauth`, {
            method: 'GET',
            headers: {
                Cache: 'no-cache',
            },
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(items => {
                console.log(`return: /pauserauth`)
                console.log(items)
                if (items.refreshTokenActive) {
                    this.setState({
                        cloudStorageConnected: true,
                    })
                } else {
                    this.setState({
                        cloudStorageConnected: false,
                    })
                }
            })
            .catch(err => {
                throw Error(err.message).stack
            })
    }

    getTranslate = () => {
        fetch(`${redirectToStorage}/gettranslations`, {
            method: 'GET',
            headers: {
                Cache: 'no-cache',
            },
            credentials: 'include',
        })
            .then(response => {
                console.log(`return: /gettranslations`)
                console.log(response)
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(items => {
                this.setState({
                    translateData: items,
                })
            })
            .catch(err => {
                throw Error(err.message).stack
            })
    }

    render() {
        return (
            <div className="mainPage">
                {this.AddCloudStorage()}
                {this.AddPersonalInfo()}
            </div>
        )
    }

    AddCloudStorage = () => {
        if (
            this.state.cloudStorageConnected ||
            this.state.cloudStorageConnected === null ||
            this.state.translateData === null
        )
            return null
        return (
            <CloudStorage
                ethAddress={this.props.ethAddress}
                translate={this.state.translateData}
            />
        )
    }

    AddPersonalInfo = () => {
        if (
            !this.state.cloudStorageConnected ||
            this.state.translateData === null
        )
            return null
        return (
            <PersonalInfo
                ethAddress={this.props.ethAddress}
                translate={this.state.translateData}
            />
        )
    }
}
